import { IHttpApi, THTTPRequestMethod } from '@cian/http-api/shared';
import { TURIScheme, mergeBaseUri } from '@cian/http-api/shared/uri';

export interface IHTTPSimplifiedRequestConfig {
  uri: {
    scheme?: TURIScheme;
    host?: string;
    port?: number;
    path: string;
    query?: string;
  };
  method?: THTTPRequestMethod;
  headers?: [string, string][];
  body?: string;
}

export interface IMakeRequest {
  <T>(requestConfig: IHTTPSimplifiedRequestConfig, debug?: boolean): Promise<T>;
}

export function createMakeRequest(
  httpApi: IHttpApi,
  apiBaseUrl: string,
  subdomain: string,
  proxyHeaders?: [string, string][],
): IMakeRequest {
  let headers: [string, string][] = [];

  if (proxyHeaders) {
    headers = headers.concat(proxyHeaders);
  }

  return async <T>(requestConfig: IHTTPSimplifiedRequestConfig): Promise<T> => {
    const config = {
      uri:
        (apiBaseUrl &&
          !requestConfig.uri.host &&
          mergeBaseUri(apiBaseUrl, {
            host: (host): string => `${subdomain}.${host}`,
            path: requestConfig.uri.path,
            query: requestConfig.uri.query,
          })) ||
        requestConfig.uri,
      method: requestConfig.method,
      headers: requestConfig.headers ? headers.concat(requestConfig.headers) : headers,
      body: requestConfig.body,
    };

    if (!config.uri.host) {
      throw new Error(`Host is not configured for request: ${JSON.stringify(config)}`);
    }

    // tslint:disable-next-line: no-any
    const response = await httpApi.httpRequest(config as any);

    return JSON.parse(response.responseBody);
  };
}
